(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["miralleve-central-ajuda"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('miralleve-help-center')) {
    class MiralleveHelpCenter extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.search = this.querySelector('[data-help-search]');
        this.questions = [...this.querySelectorAll('[data-help-question]')];
        this.categories = [...this.querySelectorAll('[data-help-category]')];
        this.status = this.querySelector('[data-help-status]');
        this.empty = this.querySelector('[data-help-empty]');
        this.reset = this.querySelector('[data-help-reset]');
        this.faq = this.querySelector('[data-help-faq]');
        this.questions.forEach((item) => {
          item.dataset.normalizedSearch = this.normalize(item.dataset.search || '');
          const details = item.querySelector('details');
          details?.addEventListener('toggle', () => this.closeSiblings(details));
        });
        this.search?.addEventListener('input', () => this.filterSearch());
        this.categories.forEach((button) => button.addEventListener('click', () => this.filterCategory(button)));
        this.reset?.addEventListener('click', () => this.showPopular(true));
        this.showPopular(false);
      }

      normalize(value) {
        return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
      }

      closeSiblings(opened) {
        if (!opened.open || this.dataset.singleOpen !== 'true') return;
        this.questions.forEach((item) => {
          const details = item.querySelector('details');
          if (details && details !== opened) details.open = false;
        });
      }

      applyFilter(predicate, interactive) {
        let count = 0;
        this.questions.forEach((item) => {
          const visible = predicate(item);
          item.hidden = !visible;
          if (visible) count += 1;
        });
        if (this.empty) this.empty.hidden = count > 0;
        if (this.status) {
          const template = count === 1 ? this.dataset.resultsSingular : this.dataset.resultsPlural;
          this.status.textContent = interactive ? (template || '').replace('[count]', String(count)) : '';
        }
      }

      showPopular(scroll) {
        if (this.search) this.search.value = '';
        this.categories.forEach((button) => button.setAttribute('aria-pressed', 'false'));
        const hasPopular = this.questions.some((item) => item.dataset.popular === 'true');
        this.applyFilter((item) => !hasPopular || item.dataset.popular === 'true', false);
        if (this.reset) this.reset.hidden = true;
        if (scroll) this.faq?.scrollIntoView({ behavior: this.reduceMotion() ? 'auto' : 'smooth', block: 'start' });
      }

      filterSearch() {
        const term = this.normalize(this.search?.value || '');
        this.categories.forEach((button) => button.setAttribute('aria-pressed', 'false'));
        if (!term) {
          this.showPopular(false);
          return;
        }
        this.applyFilter((item) => item.dataset.normalizedSearch.includes(term), true);
        if (this.reset) this.reset.hidden = false;
      }

      filterCategory(button) {
        const category = button.dataset.helpCategory;
        if (this.search) this.search.value = '';
        this.categories.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        this.applyFilter((item) => item.dataset.category === category, true);
        if (this.reset) this.reset.hidden = false;
        this.faq?.scrollIntoView({ behavior: this.reduceMotion() ? 'auto' : 'smooth', block: 'start' });
      }

      reduceMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }
    }

    customElements.define('miralleve-help-center', MiralleveHelpCenter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["miralleve-video-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('miralleve-video-testimonials')) {
    class MiralleveVideoTestimonials extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        this.videos = [...this.querySelectorAll('video')];
        this.addEventListener('click', this.handleClick.bind(this), {
          signal: this.abortController.signal
        });

        for (const video of this.videos) {
          const shell = video.closest('[data-miralleve-video-shell]');
          video.addEventListener('play', () => shell?.classList.add('is-playing'), {
            signal: this.abortController.signal
          });
          video.addEventListener('pause', () => shell?.classList.remove('is-playing'), {
            signal: this.abortController.signal
          });
          video.addEventListener('ended', () => shell?.classList.remove('is-playing'), {
            signal: this.abortController.signal
          });
        }

        this.loadPosters();
      }

      disconnectedCallback() {
        this.posterObserver?.disconnect();
        this.abortController?.abort();
      }

      loadPosters() {
        const hydrate = () => {
          for (const video of this.videos) {
            if (!video.poster && video.dataset.poster) video.poster = video.dataset.poster;
          }
        };

        if (!('IntersectionObserver' in window)) {
          hydrate();
          return;
        }

        this.posterObserver = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          hydrate();
          this.posterObserver.disconnect();
        }, { rootMargin: '300px 0px' });
        this.posterObserver.observe(this);
      }

      async handleClick(event) {
        const button = event.target.closest('[data-miralleve-video-play]');
        if (!button || !this.contains(button)) return;

        const shell = button.closest('[data-miralleve-video-shell]');
        const video = shell?.querySelector('video');
        if (!video) return;

        for (const otherVideo of this.videos) {
          if (otherVideo !== video) otherVideo.pause();
        }

        const sources = [...video.querySelectorAll('source[data-src]')];
        const source = sources.find((candidate) => candidate.dataset.src.includes('HD-720p')) ?? sources[0];
        if (source && !source.src && source.dataset.src) {
          for (const candidate of sources) {
            if (candidate !== source) candidate.remove();
          }
          source.src = source.dataset.src;
          video.load();
        }

        video.controls = true;
        video.muted = false;

        try {
          await video.play();
        } catch (error) {
          shell.classList.remove('is-playing');
        }
      }
    }

    customElements.define('miralleve-video-testimonials', MiralleveVideoTestimonials);
  }

  } catch(e) { console.error(e); }
})();
})();
